/**
 * Branded placeholder shown in any image slot whose `src` is missing, unsafe,
 * one of Kalshi's own fallback images, or fails to load. Mirrors the web app's
 * `MarketImageFallback` (APPS-5135) so widget and web share the same
 * on-brand affordance: the Predictor mark on a #121212 tile, per Figma
 * 14197:42799 (MultiChoiceMarketImage).
 *
 * The design places the mark at 35.8x27.3 inside a 48x48 box. The mark is
 * sized as a percentage of the slot (74.6% x 56.9%) so it keeps those
 * proportions at any container size, and the svg's own viewBox letterboxes
 * it inside that percent box. Shape (round in the preview, rounded-2xl in
 * the card header, square-ish in contender rows) comes from the parent's
 * `overflow-hidden` mask, so this component just fills 100%.
 *
 * Decorative: `aria-hidden` on the tile (mirroring the web component), no
 * text. The market title next to the slot is the authoritative label.
 */

import type { JSX } from "preact";
import rawPredictorMark from "../assets/images/predictor-mark.svg";

export function ImageFallback(): JSX.Element {
  return (
    <div
      aria-hidden="true"
      className="pw:flex pw:h-full pw:w-full pw:items-center pw:justify-center pw:overflow-hidden pw:bg-widget-image-fallback pw:text-type-primary-foreground"
    >
      <span
        className="pw:h-[56.9%] pw:w-[74.6%]"
        // eslint-disable-next-line react/no-danger -- inlined bundled asset, no user input
        dangerouslySetInnerHTML={{ __html: rawPredictorMark }}
        style={{ display: "block", lineHeight: 0 }}
      />
    </div>
  );
}
